import React from 'react'

import { IDealStructureV7Data } from '@unionco/alaris-app-types'
import { StyledMarkDown } from 'components/MarkDown'
import { ModuleCard } from 'components'

interface IDealStructureV7ModuleProps {
    data: IDealStructureV7Data
}

export const DealStructureV7Module: React.FC<
    IDealStructureV7ModuleProps
> = ({ data: { items } }) => {
    if (!items) return <></>
    const title = 'Deal Structure and Economics'
    return (
        <>
            <div className="u-text-left">
                <h5 className="u-self-start u-pb-6 u-text-left">{title}</h5>
                {items && (
                    <ModuleCard.Body
                        innerCardPadding={['u-px-8', 'u-py-6']}
                        key="DealStructureV7"
                        useNewStyling={true}
                    >
                        <StyledMarkDown content={items.value} />
                    </ModuleCard.Body>
                )}
            </div>
        </>
    )
}

export default DealStructureV7Module
